import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"
import { turboRefresh } from "../lib/helpers"

export default class extends Controller {
  connect() {
    reactor(this)
    this.interval = setInterval(this.tick.bind(this), 1000)
    this.tick()
  }

  disconnect() {
    clearInterval(this.interval)
  }

  morph() {
    this.tick()
  }

  tick() {
    const timestamp = parseInt(this.element.dataset.timeUntilInWordsTimestampValue, 10)
    const remaining = Math.max(0, timestamp - Math.floor(Date.now() / 1000))

    if (remaining === 0) {
      clearInterval(this.interval)
      turboRefresh()
    } else if (remaining >= 60) {
      const minutes = Math.ceil(remaining / 60)
      this.element.textContent = `${minutes} ${minutes === 1 ? "minute" : "minutes"}`
    } else {
      this.element.textContent = `${remaining} ${remaining === 1 ? "second" : "seconds"}`
    }
  }
}
